import { filter } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { getConnectedUserJwt } from "src/core-logic/domain/admin/admin.helpers";
import { removeUserFromAgencySlice } from "src/core-logic/domain/agencies/remove-user-from-agency/removeUserFromAgency.slice";
import { catchEpicError } from "src/core-logic/storeConfig/catchEpicError";
import type {
  ActionOfSlice,
  AppEpic,
} from "src/core-logic/storeConfig/redux.helpers";

export type RemoveUserFromAgencyAction = ActionOfSlice<
  typeof removeUserFromAgencySlice
>;

type RemoveUserFromAgencyEpic = AppEpic<
  RemoveUserFromAgencyAction | { type: "do-nothing" }
>;

const removeAgencyUserEpic: RemoveUserFromAgencyEpic = (
  action$,
  state$,
  { agencyGateway },
) =>
  action$.pipe(
    filter(
      removeUserFromAgencySlice.actions.removeUserFromAgencyRequested.match,
    ),
    switchMap((action) =>
      agencyGateway
        .removeUserFromAgency$(
          action.payload,
          getConnectedUserJwt(state$.value),
        )
        .pipe(
          map(() =>
            removeUserFromAgencySlice.actions.removeUserFromAgencySucceeded(
              action.payload,
            ),
          ),
          catchEpicError((error) =>
            removeUserFromAgencySlice.actions.removeUserFromAgencyFailed({
              errorMessage: error.message,
              feedbackTopic: action.payload.feedbackTopic,
            }),
          ),
        ),
    ),
  );

export const removeUserFromAgencyEpics = [removeAgencyUserEpic];
